export default "__VITE_ASSET__BqTYP4qQ__"